<span
  *ngIf="count"
  class="black-10 bg-black-3 dot caption-2 bold500 height-1 flex-center"
  [style.width]="width">
  {{ count }}
</span>
